// extracted by mini-css-extract-plugin
export default {"root":"_1Cn7JuZ8R0Pf5IKaZUJHeu","container":"_2CE9lSLHKOG6RWW0O7rHkt"};